import React from 'react';
import { InlineDownloadCronI18n } from '@bingads-webui-campaign/inline-download-cron-i18n';
import InlineFrequency from '../actions/inline-edit/frequency';

export default ({
  i18n, legacyI18n, handleInlineEditSuccess, notifyErrorPipe,
}) => ({
  key: 'scheduled-frequency',
  name: i18n.getString(_TL_('Scheduled frequency')),
  fieldName: 'Cron',
  minWidth: 200,
  maxWidth: 250,
  isResizable: true,
  sortable: true,
  data: 'string',
  inlineEdit: true,
  onRender: (item) => {
    const cronI18n = new InlineDownloadCronI18n({ i18n: legacyI18n });
    const { Cron } = item;
    return cronI18n.formatCron(Cron);
  },
  onRenderInlineEdit: (e, item, hanelDismiss, cell) => (
    <InlineFrequency
      item={item}
      target={cell}
      legacyI18n={legacyI18n}
      onDismiss={() => hanelDismiss()}
      onActionSuccess={() => handleInlineEditSuccess()}
      notifyErrorPipe={notifyErrorPipe}
    />
  ),
});
